/*eslint-disable no-unused-vars */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { CoverageTypeFilter } from './CoverageTypeFilter';
import './index.scss';
import DatePickerComponent from 'src/Admin/components/common/DatePicker';
import { ServiceCodeNameSearch } from './ServiceNameCodeSearch';
import { useSelector } from 'react-redux';

export const Filter = ({
  onChangeEffectiveDate,
  coverageTypeOptions,
  coverageChangeHandler,
  selectedCoverage,
  effectiveDate,
  networkOptions,
  selectedNetwork,
  onChangeNetwork,
  serviceCodeNames,
  onServiceCodeNameChange,
  selectedServiceCodeName,
}) => {
  const {
    //Display_Network_For_Coverage_Admin,
    //Value_Network_For_Coverage_Admin,
    Display_Network_For_Accumulators_Admin,
    Value_Network_For_Accumulators_Admin,
  } = useSelector((state) => state.app.appConfigs.Network_Setting);
  return (
    <>
      <Row className="filter-bar-accumulator align-items-center mx-0">
        <Col md={3} className="coverage-type pl-0">
          {/*<TextInput
            parentClassName="height-32"
            inputProps={{ placeholder: 'By Service Name or Code' }}
            append={<SearchSVG.SearchSVG className="primary-text-color" />}
          />*/}
          <ServiceCodeNameSearch
            options={serviceCodeNames}
            onChange={onServiceCodeNameChange}
            value={selectedServiceCodeName}
          />
        </Col>
        <Col md={3} className="coverage-type right-border pl-0">
          <DatePickerComponent
            showIcon
            placeholder="Effective Date"
            onChange={onChangeEffectiveDate}
            value={effectiveDate}
            allowFutureDates={true}
          />
        </Col>
        <Col md={3}>
          <div className="coverage-type">
            <div className="filter-data align-items-center row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    <b>Coverage Type: </b>
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <CoverageTypeFilter
                  options={coverageTypeOptions}
                  onChange={coverageChangeHandler}
                  value={selectedCoverage}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col md={3}>
          {Display_Network_For_Accumulators_Admin === true &&
            networkOptions?.length > 0 && (
              <div className="coverage-type">
                <div className="filter-data align-items-center row">
                  <div className="col-md-4">
                    <p>
                      <span className="">
                        <b>
                          {Display_Network_For_Accumulators_Admin === 'tier'
                            ? 'Network Tier : '
                            : 'Network:'}
                        </b>
                      </span>
                    </p>
                  </div>
                  <div className="col-md-8">
                    <CoverageTypeFilter
                      options={networkOptions}
                      onChange={(value) => {
                        console.log('network filter changed', value);
                        onChangeNetwork(value);
                      }}
                      value={selectedNetwork}
                    />
                  </div>
                </div>
              </div>
            )}
        </Col>
      </Row>
    </>
  );
};
